var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "userId",
                    label: "作者id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入作者id" },
                    model: {
                      value: _vm.model.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "userId", $$v)
                      },
                      expression: "model.userId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "title",
                    label: "标题",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.model.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "title", $$v)
                      },
                      expression: "model.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "content",
                    label: "内容",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.model.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "content", $$v)
                      },
                      expression: "model.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "imageUrl",
                    label: "图片链接",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入图片链接" },
                    model: {
                      value: _vm.model.imageUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "imageUrl", $$v)
                      },
                      expression: "model.imageUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "videoUrl",
                    label: "视频链接",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入视频链接" },
                    model: {
                      value: _vm.model.videoUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "videoUrl", $$v)
                      },
                      expression: "model.videoUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "videoTag",
                    label:
                      "文章类别\n1.心理健康\n2.家庭教育\n3.专家讲座\n4.亲子关系\n5.情绪管理\n6.育儿经验\n7.安全教育\n8.沟通技巧",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.videoTag,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "videoTag", $$v)
                      },
                      expression: "model.videoTag",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "worksNarrate",
                    label:
                      "作品声明 (1.取材网络  2.引用站内 3.个人观点，仅供参考 4.引用AI 5.虚构演绎，故事经历 )",
                  },
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        "请输入作品声明 (1.取材网络  2.引用站内 3.个人观点，仅供参考 4.引用AI 5.虚构演绎，故事经历 )",
                    },
                    model: {
                      value: _vm.model.worksNarrate,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "worksNarrate", $$v)
                      },
                      expression: "model.worksNarrate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "chargeStatus",
                    label: "收费状态 (0.不收费文章 1.收费文章)",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.chargeStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "chargeStatus", $$v)
                      },
                      expression: "model.chargeStatus",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "contentType",
                    label: "文章类型 (1.文章 2.视频 3.主题文章)",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.contentType,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "contentType", $$v)
                      },
                      expression: "model.contentType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "status",
                    label: "审核状态 (0.审核中 1.已发布 2未通过 3.草稿）",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "status", $$v)
                      },
                      expression: "model.status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "creationType",
                    label: "创作类型 1 原创 2转载",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.creationType,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "creationType", $$v)
                      },
                      expression: "model.creationType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "showCount",
                    label: "展现量",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.showCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "showCount", $$v)
                      },
                      expression: "model.showCount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "viewCount",
                    label: "浏览量",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.viewCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "viewCount", $$v)
                      },
                      expression: "model.viewCount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "playBackDuration",
                    label: "播放时长",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入播放时长" },
                    model: {
                      value: _vm.model.playBackDuration,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "playBackDuration", $$v)
                      },
                      expression: "model.playBackDuration",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "source",
                    label: "来源 0-PC  1-app",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.source,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "source", $$v)
                      },
                      expression: "model.source",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }